import React from "react";
import { FaWheelchair } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

export default function PlateModal({
  setIsPlateModalOpen,
  plateModalLetter,
  setPlateModalLetter,

  isPlateModalNextInputOpen,
  setIsPlateModalNextInputOpen,
}) {
  const selectPlate = (e) => {
    setPlateModalLetter(e.target.innerHTML);
    setIsPlateModalOpen(false);
    if (setIsPlateModalNextInputOpen) setIsPlateModalNextInputOpen(true);
  };
  return (
    <div
      className="absolute w-full h-screen backdrop-blur-sm flex flex-col items-center justify-center z-[1001] px-[8vw] "
      onClick={() => {
        setIsPlateModalOpen(false);
      }}
    >
      <div className="w-full flex flex-col items-center justify-center ">
        <div
          className="w-full flex items-center justify-center bg-color-primary-D font-font_primary_A text-[#153038] rounded-[1vw] "
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span className="py-[2vw]">انتخاب حرف پلاک </span>
        </div>
        <div className="w-full flex flex-col items-center justify-center font-font_primary_A text-[#FFF] bg-[#001D26] gap-y-[3vw] p-[2vw] py-[4vw] rounded-[1vw]">
          <div className="w-full flex items-center justify-between">
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              الف
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ب
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              پ
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ت
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ث
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ج
            </span>
          </div>
          <div className="w-full flex items-center justify-between">
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              چ
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ح
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              خ
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              د
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ذ
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ر
            </span>
          </div>
          <div className="w-full flex items-center justify-between">
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ز
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ژ
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              س
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ش
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ص
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ض
            </span>
          </div>
          <div className="w-full flex items-center justify-between">
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ط
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ظ
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ع
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              غ
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ف
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ق
            </span>
          </div>
          <div className="w-full flex items-center justify-between">
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ک
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              گ
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ل
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              م
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ن
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              و
            </span>
          </div>
          <div className="w-full flex items-center justify-evenly">
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ه
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              ی
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={(e) => {
                setPlateModalLetter("&");
                setIsPlateModalOpen(false);
                if (setIsPlateModalNextInputOpen)
                  setIsPlateModalNextInputOpen(true);
              }}
            >
              <FaWheelchair />
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              D
            </span>
            <span
              className="bg-[rgba(226,227,229,0.2)] w-[10vw] h-[10vw] flex items-center justify-center rounded-[1.8vw] p-[2vw]"
              onClick={selectPlate}
            >
              S
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
